module.exports = __webpack_public_path__ + "img/eq-weapon.52a97340.png";